import { render } from "./UnAuthorized.vue?vue&type=template&id=1ae9ec03&scoped=true&ts=true"
import script from "./UnAuthorized.vue?vue&type=script&lang=ts"
export * from "./UnAuthorized.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae9ec03"]])

export default __exports__